export const SITE_URL = "https://albazar.az";

const MAP: Record<string, string> = {
  ə: "e", ç: "c", ğ: "g", ı: "i", İ: "i", ö: "o", ş: "s", ü: "u",
  Ə: "e", Ç: "c", Ğ: "g", Ö: "o", Ş: "s", Ü: "u",
};

export function slugify(value: string): string {
  return value
    .split("")
    .map((ch) => MAP[ch] ?? ch)
    .join("")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 70)
    .replace(/-+$/g, "");
}

const UUID_RE = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i;

/** SEO-dostu URL parçası: iphone-15-pro-max-256gb-baki-<id> */
export function adSlug(ad: { id: string; title: string; city?: string }): string {
  const base = slugify(`${ad.title} ${ad.city ?? ""}`);
  return base ? `${base}-${ad.id}` : String(ad.id);
}

/** Slug-dan həqiqi elan ID-sini çıxarır */
export function idFromSlug(slug: string): string {
  const uuid = slug.match(UUID_RE);
  if (uuid) return uuid[0];
  const numeric = slug.match(/(\d+)$/);
  return numeric ? numeric[1]! : slug;
}

export function adImageAlt(ad: { title: string; city?: string }, index = 0): string {
  const base = `${ad.title}${ad.city ? ` ${ad.city}` : ""}`;
  return index === 0 ? base : `${base} — şəkil ${index + 1}`;
}
